const useAuth = (): boolean => !!localStorage.getItem('token')

export default useAuth
